/**
 * Created by Ning Jiang on 12/4/2018.
 */

import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IdleAnimationController} from "@nolimitcity/slot-game/bin/game/idleanimation/IdleAnimationController";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TombstoneGameConfig} from "../TombstoneGameConfig";
import {TombstoneSoundConfig} from "../TombstoneSoundConfig";

export class WindIdleAnimation extends IdleAnimationController {

    private _betWinsData:IBetWinData[] | null;
    private _wind:TimelineSprite;

    constructor() {
        super({
            startTime : 6,
            minInterval : 8,
            maxInterval : 25
        });
    }

    protected onGameDataParsed(data:ParsedGameData):void {
        this._betWinsData = data.betWins;
    }

    protected hasWin():boolean {
        return this._betWinsData != null && this._betWinsData.length > 0;
    }

    protected playIdleAnimation():void {
        if(!this._wind) {
            this._wind = new TimelineSprite(GameResources.getTextures("wind"), 30);
            this._wind.blendMode = PIXI.BLEND_MODES.SCREEN;
            this._wind.scale.set(2);
            this._wind.hide();
            const layer:ScalableLayer = StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.IDLE_FOREGROUND.name);
            layer.addChild(this._wind);
        }
        this._wind.position.set(-361, 518 - (StageManager.orientation === Orientation.PORTRAIT ? 0 : 150));
        this._wind.getAnimationAutoShowHide();
        SlotGame.sound.playEffect(TombstoneSoundConfig.instance.WIND);
    }
}